var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_4729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.55556V1M4.5 2.55556V1M1.19444 4.88889H14.8056M1 6.47867C1 4.83367 1 4.01078 1.33911 3.38233C1.64558 2.82166 2.12143 2.37221 2.69867 2.09822C3.36444 1.77778 4.23556 1.77778 5.97778 1.77778H10.0222C11.7644 1.77778 12.6356 1.77778 13.3013 2.09822C13.887 2.37978 14.3622 2.82933 14.6609 3.38156C15 4.01156 15 4.83444 15 6.47944V10.2999C15 11.9449 15 12.7678 14.6609 13.3962C14.3544 13.9569 13.8786 14.4063 13.3013 14.6803C12.6356 15 11.7644 15 10.0222 15H5.97778C4.23556 15 3.36444 15 2.69867 14.6796C2.12155 14.4058 1.64571 13.9566 1.33911 13.3962C1 12.7662 1 11.9433 1 10.2983V6.47867Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_4729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.7cfa26866838e6113e1c987b41684939.svg";
export { ForwardRef as ReactComponent };